export default "__VITE_ASSET__BSEk1AIN__"